module.exports = __webpack_public_path__ + "static/media/Niveau_elN6_4_827354.c74d51e3.png";